import React, { useState, useEffect } from 'react';
import FURGAPI from '../../../services/api.furg';
import ItemRecurso from './InfoRecurso';
import { Loading } from '../../../components/Loading';
import { getToken } from '../../../services/auth';
import { Alert } from '../../Alert';

const Recurso = ({ children, vestibular, equipeId = null, initial, situacao }) => {
    const [justificativa, setJustificativa] = useState(initial.justificativa_candidato);
    const [protocolo, setProtocolo] = useState(initial.nr_protocolo_envio);
    const [dataEnvio, setDataEnvio] = useState(initial.dt_envio);
    const [parecer] = useState(initial.tx_parecer);

    const [tela, setTela] = useState(situacao !== 'aberto' ? 'justificativa' : initial.nr_protocolo_envio ? 'justificativa' : 'edicao');
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState('');
    const [erro, setErro] = useState('');

    /**
     * Entrada initial = {
        id_equipe_avaliacao, nm_equipe, justificativa_candidato, dt_envio, nr_protocolo_envio, dt_avaliacao, fl_recurso_aceito, tx_parecer
    }; */

    useEffect(() => {
        // Situações das etapas do recurso (aguardando_aberturam, aberto, aguardando_resultado, fechado)
        if (situacao === 'aberto' || situacao === 'aguardando_resultado') {
            setStatus(!!protocolo ? 'enviado' : 'pendente');
        } else if (situacao === 'fechado') {
            if (initial.fl_recurso_aceito === null && initial.nr_protocolo_envio === null) {
                setStatus('fechado_pendente');
            } else {
                setStatus(initial.fl_recurso_aceito === 'S' ? 'deferido' : 'indeferido');
            }
        }
    }, [initial.fl_recurso_aceito, situacao, protocolo, initial.nr_protocolo_envio]);

    const statusTraducoes = {
        'pendente': {
            tipo: 'warning',
            mensagem: 'Recurso não foi aberto',
        },
        'fechado_pendente': {
            tipo: 'danger',
            mensagem: 'Recurso não foi aberto',
        },
        'enviado': {
            tipo: 'success',
            mensagem: 'Recurso enviado',
        },
        'deferido': {
            tipo: 'success',
            mensagem: (
                <>
                    Recurso <strong>aceito e deferido</strong> pela comissão avaliadora
                </>
            ),
        },
        'indeferido': {
            tipo: 'danger',
            mensagem: (
                <>
                    Recurso <strong>aceito e indeferido</strong> pela comissão avaliadora
                </>
            ),
        },
    };

    const salvarJustificativa = e => {
        if ((justificativa?.length ?? 0) > 4000) {
            setErro('A justificativa não pode ter mais que 4000 caracteres.');
            return;
        }

        setLoading(true);
        setErro('');

        const token = getToken(vestibular);
        FURGAPI.call('sischamamentos/Publico/registrarRecurso', {
            equipe_avaliacao_id: equipeId,
            token,
            justificativa,
        }).then(
            ret => {
                setDataEnvio(ret.dt_registro_protocolo);
                setProtocolo(ret.protocolo);
                setTela('justificativa');
                setLoading(false);
            },
            error => {
                setLoading(false);
                setErro(error);
            }
        );
    };

    let abaAtiva = 'justificativa';
    if (situacao === 'fechado' && initial.fl_recurso_aceito === 'N') {
        abaAtiva = 'parecer';
    }

    const carecteresRestantes = 4000 - (justificativa?.length ?? 0);

    if (equipeId === null) {
        return <></>;
    }

    if (loading) {
        return <Loading />;
    }

    return (
        <div className={`border mb-4 d-flex flex-column justify-content-between`} style={{ minWidth: '24%' }}>
            <div className={`p-2 alert alert-${statusTraducoes[status]?.tipo}`}>
                <p className="font-weight-bold mb-2">{children}</p>
                {dataEnvio && <ItemRecurso label="Data de envio" valor={dataEnvio} />}
                {protocolo && <ItemRecurso label="Protocolo" valor={protocolo} />}
                <ItemRecurso label="Situação" valor={statusTraducoes[status]?.mensagem} />
            </div>
            <div className="p-2">
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className={`nav-item nav-link ${abaAtiva === 'justificativa' ? 'active' : ''}`}
                            id={`nav-justificativa-${equipeId}-tab`}
                            data-toggle="tab"
                            href={`#nav-justificativa-${equipeId}`}
                            role="tab"
                            aria-controls={`nav-justificativa-${equipeId}`}
                            aria-selected={abaAtiva === 'justificativa'}
                        >
                            Justificativa
                        </a>
                        <a
                            className={`nav-item nav-link ${abaAtiva === 'parecer' ? 'active' : ''}`}
                            data-toggle="tab"
                            id={`nav-parecer-tab-${equipeId}`}
                            href={`#nav-parecer-${equipeId}`}
                            role="tab"
                            aria-controls={`nav-parecer-${equipeId}`}
                            aria-selected={abaAtiva === 'parecer'}
                        >
                            Parecer
                        </a>
                    </div>
                </nav>
                <div className="tab-content" id="nav-tabContent">
                    <div
                        className={`tab-pane fade ${abaAtiva === 'justificativa' ? 'show active' : ''}`}
                        id={`nav-justificativa-${equipeId}`}
                        role="tabpanel"
                        aria-labelledby={`nav-justificativa-tab-${equipeId}`}
                    >
                        {erro && <Alert variant="danger">{erro}</Alert>}

                        <div className="mb-2">
                            <textarea
                                rows={10}
                                disabled={tela === 'justificativa'}
                                className="mt-2 mb-0"
                                value={justificativa ?? ''}
                                onChange={e => setJustificativa(e.target.value)}
                                style={{ backgroundColor: tela === 'justificativa' ? '#00000012' : 'white', 'border': '1px solid #00000020', outline: 'none' }}
                            ></textarea>
                            {tela === 'edicao' && (
                                <div className="d-flex justify-content-end">
                                    <small style={{ color: carecteresRestantes < 0 ? 'red' : 'unset' }}>{carecteresRestantes} caracteres restantes</small>
                                </div>
                            )}
                        </div>

                        {situacao === 'aberto' && (
                            <div className="d-flex justify-content-end" style={{ 'columnGap': '5px' }}>
                                {tela === 'edicao' && (
                                    <>
                                        <button
                                            className="btn btn-outline-primary"
                                            onClick={() => {
                                                setTela('justificativa');
                                            }}
                                        >
                                            Cancelar
                                        </button>
                                        <button className="btn btn-primary" onClick={salvarJustificativa}>
                                            Abrir recurso
                                        </button>
                                    </>
                                )}

                                {tela === 'justificativa' && (
                                    <button
                                        className="btn btn-outline-primary"
                                        onClick={() => {
                                            setTela('edicao');
                                        }}
                                    >
                                        Editar recurso
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                    <div className={`tab-pane fade ${abaAtiva === 'parecer' ? 'show active' : ''}`} id={`nav-parecer-${equipeId}`} role="tabpanel" aria-labelledby={`nav-parecer-tab-${equipeId}`}>
                        <textarea rows={10} disabled={true} className="my-2" style={{ backgroundColor: '#00000012', 'border': '1px solid #00000020', outline: 'none' }} value={parecer ?? ''} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Recurso;
